/* istanbul ignore file */
export { default } from './PromoArea';
export { default as PromoContent } from './PromoContent';
export { default as PromoFrameworkOne } from './PromoFrameworkOne';
export { default as PromoFrameworkTwo } from './PromoFrameworkTwo';
export { default as PromoRibbon } from './PromoRibbon';
